import { render } from "./MainTitle.vue?vue&type=template&id=47ae1f6f&scoped=true"
const script = {}

import "./MainTitle.vue?vue&type=style&index=0&id=47ae1f6f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ae1f6f"]])

export default __exports__